import React, { Fragment } from 'react';
import {
  Label, Grid, Icon, Image, List, Segment, Card,
} from 'semantic-ui-react';

import ButtonCopy from '../../../components/forms/ButtonCopyToClipboard';

const getUrlReceta = (resourceId) => `${document.location.origin}/receta/${resourceId}`;

const ListadoEpisodio = (props) => {
  const { episodios } = props;
  return (
    <Fragment>
      <Grid.Row>
        <Grid.Column>
          <Segment secondary color="teal">
            <Label attached="top">Referencias</Label>
            <h5>
              <Label style={{ marginRight: '2px' }} circular color="olive" empty />
              <span style={{ marginRight: '15px' }}>{' Episodio Leve '}</span>
              <Label style={{ marginRight: '2px' }} circular color="yellow" empty />
              <span style={{ marginRight: '15px' }}>{' Episodio Medio '}</span>
              <Label style={{ marginRight: '2px' }} circular color="red" empty />
              <span style={{ marginRight: '15px' }}>{' Episodio Grave '}</span>
            </h5>
          </Segment>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row>
        <Grid.Column width={16}>
          <h3>Episodios médicos registrados</h3>
          {
        episodios.map((e) => (
          <Card fluid key={e.id}>
            <Card.Content>
              <Card.Header>
                <Label style={{ marginRight: '6px' }} circular color={e.magnitud.color} empty key={e.magnitud.color} />
                {e.titulo}
              </Card.Header>
              <Card.Meta>
                <span className="date" style={{ fontSize: '14px' }}>
                  {e.dateCreated}
                </span>
              </Card.Meta>
              <Card.Description>
                <Segment basic padded style={{ marginLeft: '6px', marginBottom: '10px', padding: '0.5rem 1.5rem' }}>
                  <Label color="teal" ribbon style={{ marginBottom: '10px' }}>
                    <Icon name="user circle" />
                    CONSULTA REALIZADA
                  </Label>
                  <p>{e.descripcion}</p>
                </Segment>
              </Card.Description>
              <Card.Description>
                <Segment basic padded style={{ marginLeft: '6px', marginBottom: '10px', padding: '0.5rem 1.5rem' }}>
                  <Label color="teal" ribbon style={{ marginBottom: '10px' }}>
                    <Icon name="checkmark box" />
                    INDICACIONES PROVISTAS
                  </Label>
                  <p>{e.indicaciones}</p>
                </Segment>
              </Card.Description>
              <Card.Description>
                { e.receta
                && (
                <Segment basic padded style={{ marginLeft: '6px', marginBottom: '10px' }}>
                  <Label color="teal" ribbon>
                    <Icon name="first aid" />
                    PRESCRIPCIÓN
                  </Label>
                  <List>
                    {/* <List.Item> */}
                    {/* <List.Icon name='check' size='small' /> */}
                    {/* <List.Content> */}
                    {/* <List.Header>{e.medicamento}</List.Header> */}
                    {/* </List.Content> */}
                    {/* </List.Item> */}
                    <List.Item>
                      <Image src={e.receta.url} as="a" size="medium" href={e.receta.url} target="_blank" />
                    </List.Item>
                    <List.Item>
                      <ButtonCopy label="Copiar Link" value={getUrlReceta(e.receta.resourceId)} />
                    </List.Item>
                  </List>
                  {/*
                    e.medicamentos.map((m,index) => {
                        return(
                            <List key={index}>
                              <List.Item>
                                <List.Icon name='check' size='small' />
                                <List.Content>
                                  <List.Header>{m.nombreComercial}</List.Header>
                                  <List.Description>Presentación: {m.presentacion}</List.Description>
                                  <List.Description>Laboratorio: {m.laboratorio}</List.Description>
                                </List.Content>
                              </List.Item>
                            </List>
                        )
                    })
                  */}
                </Segment>
                )}
              </Card.Description>
            </Card.Content>
            <Card.Content extra>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Image style={{ marginRight: '10px' }} src={e.medico.avatar} avatar />
                <span>{`${e.medico.prefijo} ${e.medico.apellido} ${e.medico.nombre}`}</span>
              </div>
            </Card.Content>
          </Card>
        ))
      }
        </Grid.Column>
      </Grid.Row>
    </Fragment>
  );
};

export default ListadoEpisodio;



// WEBPACK FOOTER //
// ./src/routes/Historial/components/ListadoEpisodios.js